import React, { useState, useEffect } from "react";
import "./RegistroPersona.css";
import { FaWhatsapp } from "react-icons/fa6";
import axios from "axios";
import { getApiUrl } from "../../../src/api/config";
 
// 🌟 Componente reutilizable para cada campo de texto/fecha con label
// flotante fijo en la parte superior del input (estilo "pill").
const Campo = ({
  label,
  required = false,
  type = "text",
  name,
  value,
  onChange,
  placeholder = "",
}) => (
  <div className="fr-field">
    <label htmlFor={name}>
      {label} {required && <span className="fr-required">*</span>}
    </label>
    <input
      id={name}
      name={name}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
    />
  </div>
);
 
const FormularioRegistro = ({
  onSubmit,
  whatsappNumero = "",
  mostrarWhatsapp = true,
}) => {
  const [solicitudCredito, setSolicitudCredito] = useState(true);
  const [aceptaTerminos, setAceptaTerminos] = useState(false);
  const [noSoyRobot, setNoSoyRobot] = useState(false);
 
  // 🌟 NUEVO: tipos de documento traídos desde la base de datos, no
  // hardcodeados. Cada uno trae { id, descripcion, tipo_persona }.
  const [tiposDocumento, setTiposDocumento] = useState([]);
 
  useEffect(() => {
    const cargarTiposDocumento = async () => {
      try {
        const response = await axios.get(getApiUrl("/tipos-documento"));
        setTiposDocumento(response.data);
      } catch (error) {
        console.error("❌ Error cargando tipos de documento:", error);
      }
    };
    cargarTiposDocumento();
  }, []);
 
  const [form, setForm] = useState({
    // 🔧 Datos "quemados" solo para revisar el estilo visual del
    // formulario ya lleno. Cuando conectemos la lógica real, esto
    // vuelve a strings vacíos (o se elimina y se deja que el usuario
    // los escriba desde cero).
    tipoDocumento: "CC",
    nroDocumento: "1152345678",
    fechaNacimiento: "1990-05-14",
    fechaExpedicion: "2010-08-20",
    primerNombre: "Juan",
    segundoNombre: "Andrés",
    primerApellido: "Pérez",
    segundoApellido: "Gómez",
    razonSocial: "",
    correo: "juan.perez@example.com",
    celular: "3001234567",
  });
 
  // 🌟 NUEVO: determina si el tipo de documento elegido corresponde a
  // persona natural o jurídica, buscando en la lista traída de la API.
  const tipoSeleccionado = tiposDocumento.find(
    (t) => t.id === form.tipoDocumento
  );
  const esJuridica = tipoSeleccionado?.tipo_persona === "juridica";
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
 
    if (!aceptaTerminos) {
      alert("Debes aceptar los Términos y Condiciones para continuar.");
      return;
    }
    if (!noSoyRobot) {
      alert("Confirma que no eres un robot para continuar.");
      return;
    }
 
    if (onSubmit) {
      onSubmit({ ...form, solicitudCredito, esJuridica });
    } else {
      console.log("📋 Formulario enviado:", { ...form, solicitudCredito, esJuridica });
    }
  };
 
  return (
    <div className="fr-page">
      <form className="fr-container" onSubmit={handleSubmit}>
        <h1 className="fr-title">Formulario de Registro</h1>
 
        <div className="fr-grid">
          <div className="fr-field">
            <label htmlFor="tipoDocumento">
              Tipo Documento <span className="fr-required">*</span>
            </label>
            <select
              id="tipoDocumento"
              name="tipoDocumento"
              value={form.tipoDocumento}
              onChange={handleChange}
            >
              <option value="">Selecciona…</option>
              {tiposDocumento.length === 0 ? (
                <option value="" disabled>
                  Cargando…
                </option>
              ) : (
                tiposDocumento.map((t) => (
                  <option key={t.id} value={t.id}>
                    {t.descripcion}
                  </option>
                ))
              )}
            </select>
          </div>
 
          <Campo
            label="Nro Documento"
            required
            name="nroDocumento"
            value={form.nroDocumento}
            onChange={handleChange}
          />
 
          {/* 🌟 NUEVO: campos condicionales según tipo de persona.
              Persona jurídica no tiene nombre/apellidos ni fecha de
              nacimiento — en su lugar, Razón Social. */}
          {esJuridica ? (
            <Campo
              label="Razón Social"
              required
              name="razonSocial"
              value={form.razonSocial}
              onChange={handleChange}
            />
          ) : (
            <Campo
              label="Fecha de Nacimiento"
              required
              type="date"
              name="fechaNacimiento"
              value={form.fechaNacimiento}
              onChange={handleChange}
            />
          )}
 
          <Campo
            label="Fecha de Expedición"
            required
            type="date"
            name="fechaExpedicion"
            value={form.fechaExpedicion}
            onChange={handleChange}
          />
 
          {!esJuridica && (
            <>
              <Campo
                label="Primer Nombre"
                required
                name="primerNombre"
                value={form.primerNombre}
                onChange={handleChange}
              />
 
              <Campo
                label="Segundo Nombre"
                name="segundoNombre"
                value={form.segundoNombre}
                onChange={handleChange}
              />
 
              <Campo
                label="Primer Apellido"
                required
                name="primerApellido"
                value={form.primerApellido}
                onChange={handleChange}
              />
 
              <Campo
                label="Segundo Apellido"
                name="segundoApellido"
                value={form.segundoApellido}
                onChange={handleChange}
              />
            </>
          )}
 
          <Campo
            label="Correo"
            required
            type="email"
            name="correo"
            value={form.correo}
            onChange={handleChange}
          />
 
          <Campo
            label="Celular"
            required
            type="tel"
            name="celular"
            value={form.celular}
            onChange={handleChange}
          />
        </div>
 
        {/* 🌟 Placeholder visual de reCAPTCHA.
            Esto es solo la maqueta visual — para que funcione de verdad
            hay que integrar el widget real de Google reCAPTCHA (v2
            checkbox), que requiere una site key y cargar su script
            oficial. Aquí solo se deja el checkbox de control interno
            (noSoyRobot) para no bloquear el envío del formulario. 
        {<div className="fr-recaptcha">
          <label className="fr-checkbox-row">
            <input
              type="checkbox"
              checked={noSoyRobot}
              onChange={(e) => setNoSoyRobot(e.target.checked)}
            />
            <span>No soy un robot</span>
          </label>
          <div className="fr-recaptcha-badge">
            <span className="fr-recaptcha-logo" aria-hidden="true" />
            <span className="fr-recaptcha-text">reCAPTCHA</span>
          </div>
        </div>*/}
 
        <label className="fr-checkbox-row fr-terminos">
          <input
            type="checkbox"
            checked={aceptaTerminos}
            onChange={(e) => setAceptaTerminos(e.target.checked)}
          />
          <span>
            <span className="fr-required">*</span> Autorizo y acepto haber
            leído los{" "}
            <a href="/terminos-y-condiciones" target="_blank" rel="noopener noreferrer">
              Términos y Condiciones
            </a>
          </span>
        </label>
 
        <div className="fr-submit-wrap">
          <button type="submit" className="fr-submit">
            REGISTRAR
          </button>
        </div>
      </form>
 
  
    </div>
  );
};
 
export default FormularioRegistro;